import { Injectable } from '@angular/core';
import { Brand, BrandKey, DEFAULT_BRAND, getCurrentBrand } from 'app/config/brands';

/**
 * Brand (Immosurance / ImmoKredita) of the domain the app runs on (#183).
 * Resolved once at startup by initBrand() in main.ts.
 */
@Injectable({ providedIn: 'root' })
export class BrandService {
    get brand(): Brand {
        return getCurrentBrand();
    }

    get key(): BrandKey {
        return this.brand.key;
    }

    get name(): string {
        return this.brand.name;
    }

    get logos(): Brand['logos'] {
        return this.brand.logos;
    }

    get isDefault(): boolean {
        return this.brand.key === DEFAULT_BRAND;
    }

    /**
     * Replaces the platform name in a (translated) text by the current brand,
     * keeping its case: 'Immosurance' / 'IMMOSURANCE' / 'immosurance'.
     * Words joined with a hyphen are replaced too ('IMMOSURANCE-account' in Dutch).
     * Domains, URLs and email addresses (immosurance.net, immosurance-x.com, @immosurance) are left as is.
     */
    rebrand(text: string): string {
        if (!text || typeof text !== 'string' || this.isDefault) {
            return text;
        }
        const name = this.brand.name;
        return text.replace(/(?<![@./\w])immosurance(?!\w|\.\w|-[\w-]*\.\w)/gi, (match) => {
            if (match === match.toUpperCase()) {
                return name.toUpperCase();
            }
            if (match === match.toLowerCase()) {
                return name.toLowerCase();
            }
            return name;
        });
    }
}
